export function ckPlayVideo(url){
    var videoObject = {
		container: '#video',//“#”代表容器的ID，“.”或“”代表容器的class
		variable: 'player',//该属性必需设置，值等于下面的new chplayer()的对象
        flashplayer:true,//如果强制使用flashplayer则设置成true
        autoplay:false,//自动播放
		video:url//视频地址
	};
	var player=new ckplayer(videoObject);
}


// WEBPACK FOOTER //
// ./src/helpers/ckplayer.js